import type { UserRecordMinimal } from '@navio/nsdk';
import type { NoddiAsyncError } from 'noddi-types';
import { NoddiIcon } from 'noddi-ui-common';
import { ApiErrorMessageInternal, NavioOverlayActions, NoddiBasicCard, NoddiButton } from 'noddi-ui-web';
import { formatPhoneNumber } from 'noddi-util';

export type ImpersonationUser = Pick<UserRecordMinimal, 'email' | 'id' | 'name' | 'phoneNumber'>;

export const ImpersonationConfirmation = ({
  user,
  isPending,
  error,
  onCancel,
  onConfirm
}: {
  user: ImpersonationUser;
  isPending: boolean;
  error: NoddiAsyncError | null;
  onCancel: () => void;
  onConfirm: () => void;
}) => (
  <div className='flex flex-col gap-5'>
    <div className='flex flex-col items-center gap-5'>
      <NoddiBasicCard className='w-full max-w-md shadow-xl'>
        <div className='flex flex-col gap-3'>
          <div className='flex items-center gap-2 text-lg font-medium'>
            <NoddiIcon name='User' />
            {user.name}
          </div>
          <div className='flex items-center gap-2 text-gray-600'>
            <NoddiIcon name='Mail' />
            {user.email}
          </div>
          <div className='flex items-center gap-2 text-gray-600'>
            <NoddiIcon name='Phone' />
            {user.phoneNumber ? formatPhoneNumber(user.phoneNumber) : 'No phone number'}
          </div>
        </div>
      </NoddiBasicCard>
      <NavioOverlayActions>
        <NoddiButton className='flex-1' variant='outline' onClick={onCancel}>
          Cancel
        </NoddiButton>
        <NoddiButton className='flex-1' loading={isPending} onClick={onConfirm}>
          Impersonate user
        </NoddiButton>
      </NavioOverlayActions>
    </div>
    {error && <ApiErrorMessageInternal error={error} />}
  </div>
);
